// extracted by mini-css-extract-plugin
module.exports = {"linkBlock":"style_linkBlock__30Vzy","smallLinkBlock":"style_smallLinkBlock__2r_ET","largeLinkBlock":"style_largeLinkBlock__ryHgN"};